import {
    ChangeDetectorRef,
    Component,
    inject,
  } from '@angular/core';
  import { FormsModule } from '@angular/forms';
  
  import { TalkService } from '../../services/talk.service';
  
  interface TalkParticipant {
    name: string;
    sex: string;
    age: number | null;
    email: string;
    phone: string;
    followUp: string;
  }
  
  @Component({
    selector: 'app-public-talk-form',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './public-talk-form.html',
    styleUrl: './public-talk-form.scss',
  })
  export class PublicTalkForm {
    private talkService = inject(TalkService);
    private cdr = inject(ChangeDetectorRef);
  
    isSubmitting = false;
    submitted = false;
  
    name = '';
    date = '';
    location = '';
  
    entrySurvey = false;
    exitSurvey = false;
  
    participants: TalkParticipant[] = [
      {
        name: '',
        sex: '',
        age: null,
        email: '',
        phone: '',
        followUp: '',
      },
    ];
  
    addParticipant(): void {
      this.participants.push({
        name: '',
        sex: '',
        age: null,
        email: '',
        phone: '',
        followUp: '',
      });
    }
  
    removeParticipant(index: number): void {
      if (this.participants.length === 1) {
        return;
      }
  
      this.participants.splice(index, 1);
    }
  
    submitForm(): void {
      if (
        !this.name ||
        !this.date ||
        !this.location
      ) {
        return;
      }
  
      this.isSubmitting = true;
  
      const talk = {
        name: this.name,
        date: this.date,
        location: this.location,
        participants: this.participants,
        entrySurvey: this.entrySurvey,
        exitSurvey: this.exitSurvey,
      };
  
      this.talkService.createTalk(talk).subscribe({
        next: (response) => {
          console.log(
            '🟢 PLÁTICA ENVIADA:',
            response,
          );
  
          this.isSubmitting = false;
          this.submitted = true;
  
          this.cdr.detectChanges();
        },
  
        error: (error) => {
          console.error(
            '🔴 ERROR ENVIANDO PLÁTICA:',
            error,
          );
  
          this.isSubmitting = false;
  
          this.cdr.detectChanges();
        },
      });
    }
  }